import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react'
import { Button, Divider, Form } from 'antd'
import { SaveOutlined } from '@ant-design/icons'
import { useNavigate, useParams } from 'react-router-dom'
import { getAssistants } from '../../../services/assistant'
import { InputSearch } from '../../../components/input-search'
import { toast } from 'sonner'
import {
  getEvolutionById,
  updateEvolutionInstance,
} from '../../../services/evolution'

export default function EditEvolution() {
  const navigate = useNavigate()
  const { id } = useParams()
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)
  const extraDataRef = useRef({})

  useEffect(() => {
    if (!id) return

    setLoading(true)
    getEvolutionById(id)
      .then(({ data }) => {
        extraDataRef.current = data
        form.setFieldsValue(data)
        setLoading(false)
      })
      .catch((e) => {
        console.error(e)
        toast.error('Falha ao carregar informações da instância')
      })
  }, [id, form])

  const save = useCallback(
    (values) => {
      setSaving(true)
      const updatedValues = {
        ...extraDataRef.current,
        ...values,
      }
      updateEvolutionInstance(id, updatedValues)
        .then(() => {
          setSaving(false)
          navigate('/myzap')
          toast.success('Instância atualizada com sucesso!')
        })
        .catch((e) => {
          console.error(e)
          setSaving(false)
          toast.error('Falha ao atualizar instância')
        })
    },
    [id, navigate]
  )

  return (
    <>
      <Form
        style={{
          maxWidth: 600,
        }}
        disabled={loading}
        layout={'vertical'}
        autoComplete="off"
        form={form}
        onFinish={save}
      >
        <Form.Item
          name="assistantID"
          label={'Assistente'}
          rules={[
            {
              required: true,
              message: 'Você deve selecionar o assistente',
            },
          ]}
        >
          <InputSearch getCallback={getAssistants} />
        </Form.Item>
        <Divider />
        <Form.Item>
          <Button
            loading={saving}
            icon={<SaveOutlined />}
            type="primary"
            htmlType="submit"
          >
            Salvar
          </Button>
        </Form.Item>
      </Form>
    </>
  )
}
